import { StatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

const Statuses = {
    BATCHED: 'BATCHED',
    NEW_LOAD: 'NEW_LOAD',
    RELEASED: 'RELEASED',
};

function getStatus(status) {
    switch (status) {
        case Statuses.BATCHED:
            return StatusIndicator.Status.IN_PROGRESS;
        case Statuses.NEW_LOAD:
            return StatusIndicator.Status.WARNING;
        default:
            return StatusIndicator.Status.DEFAULT;
    }
}

const StatusMessages = {
    [Statuses.BATCHED]: 'Batched',
    [Statuses.NEW_LOAD]: 'New Load',
    [Statuses.RELEASED]: 'Released',
};

export const ReleaseStatusIndicator = ({ status, batchName = undefined }) => (
    <StatusIndicator
        status={getStatus(status)}
        message={StatusMessages[status]}
        className="font-semi-bold--uppercase"
        tooltipText={batchName}
    />
);

ReleaseStatusIndicator.propTypes = {
    status: PropTypes.oneOf(Object.values(Statuses)).isRequired,
    batchName: PropTypes.string,
};

ReleaseStatusIndicator.Statuses = Statuses;
ReleaseStatusIndicator.StatusMessages = StatusMessages;
